import { render, staticRenderFns } from "./SimpleArrow.vue?vue&type=template&id=70e2dc3e&scoped=true&"
import script from "./SimpleArrow.vue?vue&type=script&lang=js&"
export * from "./SimpleArrow.vue?vue&type=script&lang=js&"
import style0 from "./SimpleArrow.vue?vue&type=style&index=0&id=70e2dc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e2dc3e",
  null
  
)

export default component.exports